import { includes } from 'ramda';

import { hasNoValue } from '../../util';

export const fileTypeAllowed = (file: File, allowed: string[]): boolean =>
  hasNoValue(allowed) || includes(file.type, allowed);
